module.exports = __webpack_public_path__ + "img/round_corner_card_curve.34f59016.png";